import React from 'react';

interface IProps {
  children: React.ReactNode;
}

export default function Breadcrumbs(props: IProps) {
  return (
    <ul
      className="breadcrumbs"
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      {
        React.Children.map(props.children, (child, idx) => {
          if (!child) return null;

          return (
            <li
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
              className="breadcrumbs__breadcrumb"
              key={idx}
            >
              {child}
            </li>
          );
        })
      }
    </ul>
  );
}
